export const asinCollectList = state => state.asinCollectList
